import { notification } from 'ant-design-vue';
import moment from 'moment';
export interface INotificationContent {
  title: string;
  body: string;
  key: string;
  onClick?: (ev: Event) => void;
}
declare interface WinNotification {
  sendNotification: (notificationInfo: INotificationContent) => void;
  checkNotificationStatus: () => -99 | -1 | 0 | 1;
  requestNotificationPermission: () => void;
}
declare module 'vue/types/vue' {
  interface Vue {
    $winNotification: WinNotification;
  }
}

export const checkNotificationStatus = () => {
  // 浏览器不支持
  if (!window.Notification) {
    return -99;
  }
  // 已拒绝显示通知
  if (Notification.permission === 'denied') {
    return -1;
  }
  // 用户未选择
  if (Notification.permission === 'default') {
    return 0;
  }
  // 用户允许显示通知
  if (Notification.permission === 'granted') {
    return 1;
  }
  // 其他
  return -99;
};
export const requestNotificationPermission = () => {
  if (checkNotificationStatus() === 0) {
    Notification.requestPermission();
  }
};

export const winNotification: WinNotification = {
  requestNotificationPermission,
  checkNotificationStatus,
  sendNotification(notificationInfo) {
    // 允许发系统通知
    if (checkNotificationStatus() === 1) {
      const notificationInstance = new Notification(notificationInfo.body, {
        body: '',
        tag: notificationInfo.key,
        icon: '/logo.png',
        renotify: true,
      });
      if (notificationInfo.onClick) {
        notificationInstance.onclick = notificationInfo.onClick;
      }
      return;
    }
    // 未允许发系统通知，调起界面提醒
    notification.info({
      message: notificationInfo.body,
      description: moment().format('YYYY-MM-DD HH:mm'),
      duration: 0,
      key: notificationInfo.key,
      onClick: notificationInfo.onClick,
      placement: 'bottomRight',
    });
    this.requestNotificationPermission();
  },
};
